export default {
  dialog: '0 0 20px rgba(0, 0, 0, 0.2)',
  tooltip: '0 0 20px rgba(0, 0, 0, 0.1)',
};
